/**
 * @file Error-page.jsx
 * @module ErrorPage
 * @description Kļūdu lapas komponente Karšu pārlūka maršrutēšanai.
 *              Attēlo lietotājam draudzīgu kļūdas ziņojumu, kad React Router
 *              nevar apstrādāt pieprasīto maršrutu.
 */
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="flex items-center justify-center w-full flex-col">
      <h1 className="text-2xl font-bold my-8">Oops!</h1>
      <p className="my-5">Sorry, an unexpected error has occurred.</p>
      <p className="text-slate-500">
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
